// WHAT SPLIT SEARCH HANDS THE SELECTION PANEL (owner, 2026-10-02: "the
// split search needs the same panel in the 3D view as the construction
// panel, that shows when we select, to bring all informations about an
// item of group of items"). And, asked whether it should show tracking
// data or model facts: "both pull data from tracking and show what the
// model knows" - a UNION, not a fallback.
//
// IT IS THE SAME COMPONENT, NOT A FORK AND NOT A MODE FLAG, and the
// reason is worth writing down because the instinct is to fork it:
// Tracking's SelectionDetails already renders LESS when it is told less.
// `assembly` absent means that section is not rendered at all - its own
// header says "a page that knows nothing about parts is unchanged" - and
// the filtered-only switch is behind `onFilteredOnly ? (...)`, so leaving
// the prop out removes the control. A flag would have added a second way
// to say the same thing.
//
// THE UNION IS ALREADY HOW THAT PANEL WORKS: it fetches the element's
// PROPERTIES (what the model knows) separately from the tracking summary
// that carries the numbers. Split Search needs neither branch added.
//
// THE WRITE MUST NOT TRAVEL. Tracking's panel can set status; Split
// Search is a search surface and nobody asked for it to change anything.
// The panel does not write by itself - the only write is the
// `onStatusWritten` callback a page hands it - so the guarantee here is
// OMISSION, enforced by one place building the whole prop set and a test
// asserting no write callback is in it. A guarantee by construction
// beats a guarantee by everybody remembering.

// The panel takes `{ nodeKeys } | { recordNodes } | { uniqueIds }`.
// A Split Search anchor is a search hit, not a tracking node - but it
// already carries the model's own id, and ModelPane converts it the same
// way to highlight the element in 3D, so the shapes do meet.
export function panelSelection(selected) {
  const id = selected && selected.uniqueId;
  if (!id) return null;
  return { uniqueIds: [String(id)] };
}

// Every callback on SelectionDetails that can change data. None of these
// may appear in what Split Search passes. Named here so the test does not
// have to restate the panel's API and quietly drift from it.
export const WRITE_PROPS = [
  'onStatusWritten',
  'onFilteredOnly',
  'onLevelPick',
  'onCreateSubcategory',
];

// The COMPLETE prop set, so the page spreads this and adds nothing. null
// when there is no selection, which is also the page's "render nothing".
export function panelProps({ projectId, selected, height = 320 }) {
  const selection = panelSelection(selected);
  if (!selection) return null;
  return {
    projectId,
    selection,
    // One element, named rather than counted, so the panel's "the count
    // disagrees with the selection" line has something true to compare.
    selectionCount: selection.uniqueIds.length,
    height,
  };
}
